import {
    ITEM_DETAIL_REQUEST,
    SET_EXPENDITURE,
    SET_ORDER_DETAIL,
    SET_REQUEST_OPTION,
    SET_APPROVAL_ORDER_REQUEST,
    SET_IS_ORDER_APPROVAL_COMPLETE,
    SET_GRID_COLUMNS,
    SET_ORDERS_STATUS,
    SET_FLEET_PROCESSING_GRID_DATA,
    SET_IS_ORDER_CANCELED,
    GET_ACTION_POPUP_VALUE,
    SET_PENDING_ORDERS_GRID_DATA,
    SET_GRID_ORDERS_COUNT,
    SET_MY_ORDERS_GRID_DATA,
    SET_ALL_PENDING_ORDERS_GRID_DATA,
    IS_GRID_DATA_LOADING,
    IS_GRID_COUNTS_LOADING
} from './types';

const initialState = {
    selectedItemRequest: {},
    expenditure: [],
    approvalHistory: [],
    orderDetail: {},
    requestOption: [],
    itemDetail: [],
    approverActions: [],
    isOrderApprovalComplete: [],
    orderListGridData: [],
    gridColumns: [],
    ordersStatus: [],
    fleetProcessingGridData: [],
    approvalOrderRequest: {
        orderId: 0,
        approverEmailId: '',
        approverActionId: 0,
        comment: '',
        requestApproveVMs: []
    },
    isOrderCanceled: [],
    actionPopupValue:{}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ITEM_DETAIL_REQUEST:
            return {
                ...state,
                selectedItemRequest: action.selectedRequest
            }
        case SET_EXPENDITURE:
            return {
                ...state,
                expenditure: action.expenditure
            }
        case SET_ORDER_DETAIL:
            return {
                ...state,
                orderDetail: action.value
            }
        case SET_REQUEST_OPTION:
            return {
                ...state,
                requestOption: action.value
            }
            case SET_APPROVAL_ORDER_REQUEST:
                return {
                    ...state,
                    approvalOrderRequest: action.approvalOrderRequest,
                }
            case SET_IS_ORDER_APPROVAL_COMPLETE:
                return {
                    ...state,
                    isOrderApprovalComplete: {
                        loading:false,
                        approval: action.isOrderApprovalComplete
                    }
                }
        case SET_GRID_ORDERS_COUNT:
            return {
                ...state,
                gridOrdersCount: action.count
            }
        case SET_PENDING_ORDERS_GRID_DATA:
            return {
                ...state,
                pendingOrdersGridData: action.gridData
            }
        case SET_ALL_PENDING_ORDERS_GRID_DATA:
            return {
                ...state,
                allPendingGridData: action.allPendingGridData
            }
        case SET_MY_ORDERS_GRID_DATA:
            return {
                ...state,
                myOrdersGridData: action.gridData
            }
        case SET_GRID_COLUMNS:
            return {
                ...state,
                gridColumns: action.gridColumns
            }
        case SET_ORDERS_STATUS:
            return {
                ...state,
                ordersStatus: action.ordersStatus
            }
        case SET_FLEET_PROCESSING_GRID_DATA:
            return {
                ...state,
                fleetProcessingGridData: action.fleetProcessingGridData
            }
        case SET_IS_ORDER_CANCELED:
            return {
                ...state,
                isOrderCanceled: {
                    loading:false,
                    approval: action.isOrderCanceled
                }
            }
        case  GET_ACTION_POPUP_VALUE:
            return {
                ...state,
                actionPopupValue: action.payload,
            }
        case  IS_GRID_DATA_LOADING:
            return {
                ...state,
                isGridDataLoading: action.flag,
            }
        case  IS_GRID_COUNTS_LOADING:
            return {
                ...state,
                isGridCountsLoading: action.flag,
            }
        default:
            return state
    }
}

export default reducer